import { ERevampReportReducers } from "../action-interfaces/Reports/DashboardSummary";
class FamilyTaggingPresenter {
    constructor(actions, usecases) {
        this.actions = actions;
        this.usecases = usecases;
    }
    setStopFamilyAPICall(stopFamilyAPiCall) {
        this.actions.familyDetails.setStopFamilyAPICall(stopFamilyAPiCall, ERevampReportReducers.FamilyTagging);
    }
    getFamilyDetails() {
        this.actions.familyDetails.setFamilyError({
            msg: "",
            show: false,
            icon: "",
        }, ERevampReportReducers.FamilyTagging);
        this.usecases.familyDetails.execute({
            onSuccess: (data) => {
                if (data) {
                    (this.familyData = data.familiDetails),
                        this.actions.familyDetails.getFamilyDetails(data.familiDetails, ERevampReportReducers.FamilyTagging);
                    // for default member  selected as self, whenever there is API call
                    this.actions.familyDetails.setSelectedMember(data === null || data === void 0 ? void 0 : data.myDataInFam, ERevampReportReducers.FamilyTagging);
                }
            },
            onError: (error) => {
                this.actions.familyDetails.setFamilyError({
                    msg: "",
                    show: true,
                    icon: "",
                }, ERevampReportReducers.FamilyTagging);
                this.actions.familyDetails.setError({ error: error, isOpen: true }, ERevampReportReducers.FamilyTagging);
            },
        }, null);
    }
    setSelectedFamilyMember(familyId, member, isFamilyAPIFails) {
        // when family  API fails
        if (isFamilyAPIFails)
            this.actions.familyDetails.getFamilyDetails({
                myFamilies: {},
                myAccCode: member === null || member === void 0 ? void 0 : member.accCode,
                UserIsManagerInMinOneFamily: false,
                UserIsManagerOfFamilyId: "",
            }, ERevampReportReducers.FamilyTagging);
        this.actions.familyDetails.setSelectedMember(member, ERevampReportReducers.FamilyTagging);
    }
}
export default FamilyTaggingPresenter;
